import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Select from "react-select";
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import apiClient from '../utils/apiClient';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
const GatePass = ({ accessOfDepartments }) => {
  const [validationErrors, setValidationErrors] = useState({});
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [purposeOptions, setPurposeOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [securitySewadars, setSecuritySewadars] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [formData, setFormData] = useState({
    // Common selector at the top
    gatePassCause: '', // "वाहन का गेट पास, जिसका पूरा सामान उतारा जा चुका है |" OR "वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |"
    gpNo: '',
    gatePassDate: moment().format("YYYY-MM-DD"),

    // Case: "वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |"
    isBilwaVehicle: false, // Is Center/Satsang Vehicle (हां/नहीं)
    purpose: '', // React Select
    isCarryingGoods: '', // हां/नहीं
    challanNo: '',
    challanDate: '',

    // Conditional: If Purpose is "Returnable Goods on Inward Memo"
    inwardMemoNo: '',
    inwardMemoDate: '',

    // Conditional: If Purpose is "distribution of consumables for community consumption"
    items: [
      {
        item: '',    // from itemOptions (React Select)
        quantity: '',       // auto-filled from selected item
      }
    ],

    // Common Fields (shared between both forms)
    vehicleNumber: '',
    driverName: '',
    mobileNumber: '',
    badgeId:'',
    ledgerName: '', // React tag input
    remarks: '',

    // For Empty Vehicle (Original form fields)
    freightOn: false, // false = सेवा वाहन, true = भाड़े पर लिया गया वाहन
    copyCollected: false,
    siNumber: '',

    totalFreight: '',

    transporterName: '',
    transporterGSTIN: '',

    documentGRNo: '',
    documentGRDate: '',
    documentCollected: false,

    itemsChecked: null,
    itemsCount: null,
    qualityInformed: null,
    countInformed: null
  });
  const [gatePassID, setGatePassID] = useState(null);
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const code = localStorage.getItem('code');
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email'); // Retrieve email from localStorage
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location?.state?.rowData;
  useEffect(() => {
    if (rowData) {
      handleEdit(rowData);
    }
  }, [rowData]);
  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);
    }
  };
  const fetchledgermasterdetails = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/ledgerMasters', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
      const options = response.data.map((ledger) => ({
        value: ledger.printName,
        label: ledger.printName,
        ledgerId: ledger.id,
        group: ledger.ledgerGroup,
        address: ledger.address,
        gstin: ledger.gstin
      }));
      setLedgerOptions(options);
      // setledgerMasterData(response.data);
    } catch (error) {
      console.error('Error fetching ledger master details:', error);
    }
  };
  const fetchGatePassCode = async () => {
    if (rowData) {
      return
    }
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getGatePassCode`, {
        params: { centerCode: code },
      });
      setFormData((prevData) => ({
        ...prevData,
        gpNo: response.data.gatePassCode,
      }));
    } catch (err) {
      console.error(err);
    }
  };
  const fetchDetailsBySiNumber = async (siNumber) => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getDetailsBySiNumber`, {
        params: { siNumber, code },
        headers: { Authorization: `Bearer ${token}` },
      });


      if (response.data.length) {
        setFormData((prevData) => ({
          ...prevData,
          vehicleNumber: response.data[0].vehicleNumber || '',
          driverName: response.data[0].driverName || '',
          mobileNumber: response.data[0].mobileNo || '',
          ledgerName: response.data[0].ledgerName || '',
        }));
      }
    } catch (error) {
      console.error('Error fetching details by SI Number:', error);
      Swal.fire('Error', 'Failed to fetch details. Please check the SI Number or try again.', 'error');
    }
  };
  const fetchPurposeByLedger = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/getPurposeForGatePass', {
        params: { code: code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });

      const options = response.data.map((purpose) => ({
        value: purpose.hindiPurposeName, // Adjust based on API response structure
        label: purpose.hindiPurposeName,
      }));
      setPurposeOptions(options);
    } catch (error) {
      console.error('Error fetching purposes:', error);
    }
  };
  const fetchVehicleDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getVehicleDetails`);

      // Create options with value & label as vehicleNo
      const options = response.data.map(v => ({
        value: v.vehicleNo,
        label:  `${v.vehicleNo}-${v.vehicleType}`,
      }));
      setVehicleOptions(options);
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    }
  };
  const fetchSewadars = async () => {
    const dept = "Transport";
    const res = await apiClient.get(
      `${SERVER_BASE}/getOperatorsByDepartment/${code}?department=${dept}`
    );
  
    const badgeOptions = res.data.map((s) => ({
      value: s.badgeId,
      label: `${s.badgeId} - ${s?.fullName}`,
      name: s?.fullName,
      sewadarMobileNo: s.mobileNo,
      alternateMobileNo: s.alternateMobileNo,
    }));
  
    setSecuritySewadars(badgeOptions);
  };
  
  const fetchItems = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getItemOptionsByDepartment`, {
        params: {
          code,
          accessOfDepartments
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setItemOptions(response.data.map((itm) => ({
        value: itm.id,
        label: itm.printName,
        uom: itm.uom,
      })));
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  useEffect(() => {
    fetchItems();
    fetchProfileDetails();
    fetchGatePassCode();
    fetchledgermasterdetails();
    fetchPurposeByLedger();
    fetchVehicleDetails();
    fetchSewadars();
  }, []);
  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     if (formData.siNumber && code) {
  //       fetchDetailsBySiNumber(formData.siNumber);
  //     }
  //   }, 750); // 500ms debounce
  //   return () => clearTimeout(timeoutId); // Cleanup timeout
  // }, [formData.siNumber, code]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type == 'checkbox' ? checked : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Clear validation error as soon as user enters something
    if (newValue !== '' && newValue !== null && newValue !== undefined) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleItemTableChange = (index, field, value) => {
    const updated = [...formData.items];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, items: updated }));
  };

  const addItemRow = () => {
    setFormData((prev) => ({
      ...prev,
      items: [...prev.items, { item: null, quantity: '' }],
    }));
  };

  const removeItemRow = (index) => {
    const updated = [...formData.items];
    updated.splice(index, 1);
    setFormData((prev) => ({ ...prev, items: updated }));
  };
  const handleLedgerChange = (fieldName, selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: selectedOption,
    }));

    // Clear validation error instantly if a value is selected
    if (selectedOption) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: undefined,
      }));
    }
  };
  const validateGatePassForm = (formData) => {
    let errors = {};

    const showWarning = (message) => {
      Swal.fire({
        toast: true,
        icon: 'warning',
        title: message,
        position: 'center',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    };

    // Helper to set error and show toast
    const setError = (field, message) => {
      errors[field] = message;
      showWarning(message);
    };

    if (!formData.gatePassCause.trim()) {
      setError('gatePassCause', 'Please Select Gate Pass Cause');
      setValidationErrors(errors);
      return false;
    }

    if (formData.gatePassCause == 'वाहन का गेट पास, जिसका पूरा सामान उतारा जा चुका है |') {
      if (!formData.vehicleNumber.trim()) {
        setError('vehicleNumber', 'Vehicle Number cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.driverName.trim()) {
        setError('driverName', 'Driver Name cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.mobileNumber.trim()) {
        setError('mobileNumber', 'Mobile Number cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!/^\d{10}$/.test(formData.mobileNumber)) {
        setError('mobileNumber', 'The "Mobile Number" must be exactly 10 digits.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.ledgerName) {
        setError('ledgerName', 'Ledger Name cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.documentCollected) {
        setError('documentCollected', 'Please collect documents.');
        setValidationErrors(errors);
        return false;
      }
      if (formData.itemsChecked == null) {
        setError('itemsChecked', 'Please check Item Quality.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.itemsChecked && !formData.qualityInformed) {
        setError('qualityInformed', 'Please Inform Quality at Area Office.');
        setValidationErrors(errors);
        return false;
      }
      if (formData.itemsCount == null) {
        setError('itemsCount', 'Please check Item Count.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.itemsCount && !formData.countInformed) {
        setError('countInformed', 'Please Inform Excess or Short Count at Area Office.');
        setValidationErrors(errors);
        return false;
      }
      if (formData.freightOn) {
        if (!formData.copyCollected) {
          setError('copyCollected', 'Please collect a copy.');
          setValidationErrors(errors);
          return false;
        }
        if (!formData.transporterName.trim()) {
          setError('transporterName', 'Transporter Name cannot be empty.');
          setValidationErrors(errors);
          return false;
        }
        if (!formData.documentGRNo.trim()) {
          setError('documentGRNo', 'Document GR Number cannot be empty.');
          setValidationErrors(errors);
          return false;
        }
        if (!formData.documentGRDate.trim()) {
          setError('documentGRDate', 'Document GR Date cannot be empty.');
          setValidationErrors(errors);
          return false;
        }
        if (isNaN(formData.totalFreight) || Number(formData.totalFreight) <= 0) {
          setError('totalFreight', 'Total Freight must be a positive number.');
          setValidationErrors(errors);
          return false;
        }
      }
    }

    else if (formData.gatePassCause == 'वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |') {
      if (!formData.purpose) {
        setError('purpose', 'Please Select Purpose.');
        setValidationErrors(errors);
        return false;
      }

      if (formData.purpose?.value == 'वापसी योग्य सामान जिसका इन्वार्ड मेमो बनाया गया था') {
        if (!formData.inwardMemoNo) {
          setError('inwardMemoNo', 'Please Enter Inward Memo No.');
          setValidationErrors(errors);
          return false;
        }
        if (!formData.inwardMemoDate) {
          setError('inwardMemoDate', 'Please Enter Inward Memo Date.');
          setValidationErrors(errors);
          return false;
        }
      }
      if (formData.purpose?.value == 'संगत और सेवादारों को लाने व ले जाने के लिए') {
        if (!formData.ledgerName) {
          setError('ledger', 'Please Select Ledger.');
          setValidationErrors(errors);
          return false;
        }
      }
      if (formData.isCarryingGoods) {
        if (!formData.challanNo) {
          setError('challanNo', 'Please Enter Challan No.');
          setValidationErrors(errors);
          return false;
        }
        if (!formData.challanDate) {
          setError('challanDate', 'Please Enter Challan Date.');
          setValidationErrors(errors);
          return false;
        }
      }

      if (!formData.vehicleNumber.trim()) {
        setError('vehicleNumber', 'Vehicle Number cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.driverName.trim()) {
        setError('driverName', 'Driver Name cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!formData.mobileNumber.trim()) {
        setError('mobileNumber', 'Mobile Number cannot be empty.');
        setValidationErrors(errors);
        return false;
      }
      if (!/^\d{10}$/.test(formData.mobileNumber)) {
        setError('mobileNumber', 'The "Mobile Number" must be exactly 10 digits.');
        setValidationErrors(errors);
        return false;
      }
    }

    setValidationErrors(errors);
    return true; // All validations passed
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateGatePassForm(formData)) {
      return;
    }

    const payload = {
      ...formData,
      code,
      createdBy: name,
      createdByBadge: badgeId
    };

    Swal.fire({
      title: gatePassID !== null ? 'Confirm Update' : 'Confirm Add',
      text: gatePassID !== null ? 'Are you sure you want to update this entry?' : 'Are you sure you want to add this entry?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (gatePassID !== null) {
            await apiClient.put(`${SERVER_BASE}/updateGatePass/${gatePassID}`, payload, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            setGatePassID(null);
          } else {
            await apiClient.post(`${SERVER_BASE}/addGatePass`, payload, {
              headers: {
                Authorization: `Bearer ${token}`,
              }
            });
          }
          navigate('../gatePassList')
          Swal.fire(gatePassID !== null ? 'Updated!' : 'Created!', `Your Gate Pass is saved successfully`, 'success');
        } catch (error) {
          console.error('Error saving entry:', error);
          Swal.fire('Error', 'There was an issue saving the entry. Please try again later.', 'error');
        }
      }
    });
  };

  const handleEdit = (row) => {
    const formattedItems = row.items?.map(item => ({
      item: {
        label: item?.printName || '',
        value: item?.itemId || '',
        uom: item?.uom || ''
      },
      quantity: item.quantity || ''
    })) || [];
    setGatePassID(row.id)
    setFormData((prevData) => ({
      ...prevData,
      isBilwaVehicle: row.bilwaVehicle,
      isCarryingGoods: row.isCarryingGoods,
      gatePassCause: row.gatePassCause,
      purpose: { value: row?.purpose, label: row?.purpose },
      freightOn: row.freightOn, // false for सेवा वाहन, true for भाड़े पर लिया गया वाहन
      copyCollected: row.copyCollected,
      siNumber: row.siCode,
      gpNo: row.gatePassCode,
      vehicleNumber: row.vehicleNumber,
      driverName: row.driverName,
      mobileNumber: row.mobileNum,
      badgeId: row.badgeId,
      ledgerName: { label: row.ledger, value: row.ledger, ledgerId: row.ledgerId, group: row.ledgerGroup } || { label: "", value: "" }, // Assign both label and value
      remarks: row.remarks,
      totalFreight: row.totalFreight,
      transporterName: row.transporterName,
      transporterGSTIN: row.transporterGST,
      documentGRNo: row.grNo,
      documentGRDate: row.grDate,
      documentCollected: row.documents,
      itemsChecked: row.itemsChecked,
      itemsCount: row.itemCount,
      challanNo: row.challanNo,
      challanDate: row.challanDate,
      inwardMemoNo: row.inwardMemoNo,
      inwardMemoDate: row.inwardMemoDate,
      isCarryingGoods: row.isCarryingGoods,
      qualityInformed:row.qualityInformed,
      countInformed:row.countInformed,
      items: formattedItems
    }));
  };

  return (
    <div className="container mt-5">
      <div className="row align-items-center mb-3">
        {/* Left side: Heading + Button */}
        <div className="col d-flex align-items-center">
          <button
            className="btn btn-secondary me-3"
            onClick={() => navigate('../gatePassList')}
          >
            Cancel
          </button>
          <h3 className="mb-0 ">Gate Pass</h3>
        </div>

        {/* Right side: Inputs */}
        <div className="col-auto d-flex align-items-center">
          <div className="d-flex align-items-center me-3">
            <label className="fw-bold me-2 mb-0" style={{ whiteSpace: 'nowrap' }}>
              गेट पास संख्या
            </label>
            <input
              type="text"
              name="gpNo"
              className="form-control"
              style={{ width: '150px' }}
              value={formData.gpNo}
              onChange={handleChange}
              readOnly
            />
          </div>

          <div className="d-flex align-items-center">
            <label className="fw-bold me-2 mb-0" style={{ whiteSpace: 'nowrap' }}>
              दिनांक
            </label>
            <input
              type="date"
              name="gatePassDate"
              className="form-control"
              style={{ width: '180px' }}
              value={formData.gatePassDate}
              onChange={handleChange}
              readOnly
            />
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="formcontainer">

        {/* Gate Pass Cause */}
        <div className="row mb-3">
          <div className="col-md-3 d-flex align-items-center">
            <label className="fw-bold mb-0">वाहन का गेट पास</label>
          </div>

          <div className="col-md-9">
            <div
              className={`border rounded p-2 ${!formData.gatePassCause ? 'border-danger' : ''}`}
            >
              {[
                {
                  value: 'वाहन का गेट पास, जिसका पूरा सामान उतारा जा चुका है |',
                  label: 'गेट पास, जिसका पूरा सामान उतारा जा चुका है |',
                },
                {
                  value: 'वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |',
                  label: 'गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |',
                }
              ].map((option, idx) => {
                const id = `gatePassCause-${idx}`;
                return (
                  <div key={option.value} className="form-check">
                    <input
                      type="radio"
                      id={id}
                      className="form-check-input"
                      style={{ appearance: 'checkbox' }}
                      name="gatePassCause"
                      value={option.value}
                      checked={formData.gatePassCause == option.value}
                      onChange={handleChange}
                    />
                    <label htmlFor={id} className="form-check-label">
                      {option.label}
                    </label>
                  </div>
                );
              })}

              {/* Only show text when validation has been triggered */}
              {validationErrors.gatePassCause && (
                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                  यह फ़ील्ड आवश्यक है
                </div>
              )}
            </div>
          </div>
        </div>

        {/* CONDITIONAL RENDERING */}
        {formData.gatePassCause == 'वाहन का गेट पास, जिसका पूरा सामान उतारा जा चुका है |' ? (
          <>
            {/* SI Number, Vehicle, Driver, Mobile */}
            <div className="row mb-3 align-items-center">
              {/* First Field */}
              {/* <div className="col-md-3">
                <label className="fw-bold mb-0">गेट रजिस्टर / प्राप्ति क्रमांक</label>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  name="siNumber"
                  className="form-control"
                  value={formData.siNumber}
                  onChange={handleChange}
                />
              </div> */}

              {/* Second Field */}
              <div className="col-md-3">
                <label className="fw-bold mb-0">वाहन संख्या</label>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  name="vehicleNumber"
                  className={`form-control ${!formData.vehicleNumber ? 'border-danger' : ''}`}
                  value={formData.vehicleNumber}
                  onChange={handleChange}
                />
                {!formData.vehicleNumber && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              {/* Third Field */}
              <div className="col-md-3">
                <label className="fw-bold mb-0">वाहन चालक का नाम</label>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  name="driverName"
                  className={`form-control ${!formData.driverName ? 'border-danger' : ''}`}
                  value={formData.driverName}
                  onChange={handleChange}
                />
                {!formData.driverName && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>

              {/* Fourth Field */}
              <div className="col-md-3">
                <label className="fw-bold mb-0">मोबाइल नंबर</label>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  name="mobileNumber"
                  className={`form-control ${!formData.mobileNumber ? 'border-danger' : ''}`}
                  value={formData.mobileNumber}
                  onChange={handleChange}
                />
                {!formData.mobileNumber && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            {/* Ledger & Remarks */}
            <div className="row mb-3 align-items-center">
              <label className="fw-bold col-md-3 mb-0">कहा से आया / आयेगा</label>
              <div className="col-md-9">
                <Select
                  options={ledgerOptions}
                  value={formData.ledgerName}
                  onChange={(option) => handleLedgerChange("ledgerName", option)}
                  isClearable
                  classNamePrefix={!formData.ledgerName ? 'select-danger' : 'select'}
                />
                {!formData.ledgerName && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            <style>
              {`
                .select-danger .select__control {
                  border-color: red !important;
                  box-shadow: none !important;
                }
              `}
            </style>


            <div className="row mb-3 align-items-center">
              <label className="fw-bold col-md-3 mb-0">अन्य कोई विवरण</label>
              <div className="col-md-9">
                <input
                  type="text"
                  name="remarks"
                  className="form-control"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Document Collected */}
            <div className="row mb-3">
              {/* Main Label - Vertically Centered */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">दस्तावेज प्राप्ति</label>
              </div>

              {/* Radio Options with Border */}
              <div className="col-md-9">
                <div className={`border rounded p-2 ${!formData.documentCollected ? 'border-danger' : ''}`}>
                  {[
                    { value: 'मूल दस्तावेज प्राप्त किए', label: 'मूल दस्तावेज प्राप्त किए' },
                    { value: 'मूल दस्तावेजों की प्रति प्राप्त की', label: 'मूल दस्तावेजों की प्रति प्राप्त की' }
                  ].map((option, idx) => {
                    const id = `documentCollected-${idx}`;
                    return (
                      <div key={option.value} className="form-check">
                        <input
                          type="radio"
                          id={id}
                          className="form-check-input"
                          style={{ appearance: 'checkbox' }}
                          name="documentCollected"
                          value={option.value}
                          checked={formData.documentCollected == option.value}
                          onChange={handleChange}
                        />
                        <label htmlFor={id} className="form-check-label">
                          {option.label}
                        </label>
                      </div>
                    );
                  })}
                </div>
                {!formData.documentCollected && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            {/* Items Checked */}
            {/* Row 1: Always Visible */}
            <div className="row mb-3">
              {/* Items Checked */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">क्या सामान तथा सामान की गुणवत्ता को जांचा गया?</label>
              </div>
              <div className="col-md-3">
                <div className={`border rounded p-2 ${formData.itemsChecked==undefined ? 'border-danger' : ''}`}>
                  {['हां', 'नहीं'].map((label, idx) => {
                    const id = `itemsChecked-${idx}`;
                    return (
                      <div key={label} className="form-check">
                        <input
                          type="radio"
                          id={id}
                          className="form-check-input"
                          style={{ appearance: 'checkbox' }}
                          name="itemsChecked"
                          value={label}
                          checked={formData.itemsChecked == (label == 'हां')}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              itemsChecked: e.target.value == 'हां'
                            }))
                          }
                        />
                        <label htmlFor={id} className="form-check-label">{label}</label>
                      </div>
                    );
                  })}
                </div>
                {formData.itemsChecked==undefined && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>

              {/* Items Count */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">क्या सामान की मात्रा या नगों की संख्या सही है?</label>
              </div>
              <div className="col-md-3">
                <div className={`border rounded p-2 ${formData.itemsCount==undefined ? 'border-danger' : ''}`}>
                  {['हां', 'नहीं'].map((label, idx) => {
                    const id = `itemsCount-${idx}`;
                    return (
                      <div key={label} className="form-check">
                        <input
                          type="radio"
                          id={id}
                          className="form-check-input"
                          style={{ appearance: 'checkbox' }}
                          name="itemsCount"
                          value={label}
                          checked={formData.itemsCount == (label == 'हां')}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              itemsCount: e.target.value == 'हां'
                            }))
                          }
                        />
                        <label htmlFor={id} className="form-check-label">{label}</label>
                      </div>
                    );
                  })}
                </div>
                {formData.itemsCount==undefined && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            {/* Row 2: Conditionally Visible */}
            {(formData.itemsChecked == false || formData.itemsCount == false) && (() => {
              const showQuality = formData.itemsChecked == false;
              const showCount = formData.itemsCount == false;
              const bothVisible = showQuality && showCount;

              return (
                <div className="row mb-3">
                  {/* Quality Informed */}
                  {showQuality && (
                    <>
                      <div className="col-md-3 d-flex align-items-center">
                        <label className="fw-bold mb-0">क्या गुणवत्ता की सूचना एरिया ऑफिस को दी गई?</label>
                      </div>
                      <div className={bothVisible ? "col-md-3" : "col-md-9"}>
                        <div
                          className={`border rounded p-2 ${formData.qualityInformed == undefined ? 'border-danger' : ''
                            }`}
                        >
                          {['हां','नहीं'].map((label, idx) => {
                            const id = `qualityInformed-${idx}`;
                            return (
                              <div key={label} className="form-check">
                                <input
                                  type="radio"
                                  id={id}
                                  className="form-check-input"
                                  style={{ appearance: 'checkbox' }}
                                  name="qualityInformed"
                                  value={label}
                                  checked={formData.qualityInformed == (label == 'हां')}
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      qualityInformed: e.target.value == 'हां'
                                    }))
                                  }
                                />
                                <label htmlFor={id} className="form-check-label">{label}</label>
                              </div>
                            );
                          })}
                        </div>
                        {formData.qualityInformed == undefined && (
                          <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                        )}
                      </div>
                    </>
                  )}

                  {/* Count Informed */}
                  {showCount && (
                    <>
                      <div className="col-md-3 d-flex align-items-center">
                        <label className="fw-bold mb-0">क्या मात्रा तथा नगों की सूचना एरिया ऑफिस को दी गई?</label>
                      </div>
                      <div className={bothVisible ? "col-md-3" : "col-md-9"}>
                        <div
                          className={`border rounded p-2 ${formData.countInformed == undefined ? 'border-danger' : ''
                            }`}
                        >
                          {['हां', 'नहीं'].map((label, idx) => {
                            const id = `countInformed-${idx}`;
                            return (
                              <div key={label} className="form-check">
                                <input
                                  type="radio"
                                  id={id}
                                  className="form-check-input"
                                  style={{ appearance: 'checkbox' }}
                                  name="countInformed"
                                  value={label}
                                  checked={formData.countInformed == (label == 'हां')}
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      countInformed: e.target.value == 'हां'
                                    }))
                                  }
                                />
                                <label htmlFor={id} className="form-check-label">{label}</label>
                              </div>
                            );
                          })}
                        </div>
                        {formData.countInformed == undefined && (
                          <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                        )}
                      </div>
                    </>
                  )}
                </div>
              );
            })()}

            {/* Freight On */}
            <div className="row mb-3">
              {/* Label */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">भाड़े का विवरण</label>
              </div>

              {/* Options */}
              <div className="col-md-9">
                <div className="border rounded p-2">
                  {[
                    { value: false, label: 'सेवा वाहन' },
                    { value: true, label: 'भाड़े पर लिया गया वाहन' }
                  ].map((option, idx) => {
                    const id = `freightOn-${idx}`;
                    return (
                      <div key={option.label} className="form-check">
                        <input
                          type="radio"
                          id={id}
                          className="form-check-input"
                          style={{ appearance: 'checkbox' }}
                          name="freightOn"
                          value={option.label}
                          checked={formData.freightOn == option.value}
                          onChange={() =>
                            setFormData((prev) => ({ ...prev, freightOn: option.value }))
                          }
                        />
                        <label htmlFor={id} className="form-check-label">{option.label}</label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>


            {/* Freight Fields */}
            {formData.freightOn ? (
              <>
                <div className="mb-3 form-check form-switch">
                  <input type="checkbox" className="form-check-input" name="copyCollected" checked={formData.copyCollected} onChange={handleChange} />
                  <label className="form-check-label">
                    बिल्टी तथा वाहन के भाड़े की रसीद प्राप्त की गई तथा एरिया ऑफिस को सूचित किया गया
                  </label>
                </div>
                <div className="row mb-3">
                  {/* Total Freight */}
                  <div className="col-md-3">
                    <label className="fw-bold">Total Freight</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="totalFreight"
                      className="form-control"
                      value={formData.totalFreight}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Transporter Name */}
                  <div className="col-md-3">
                    <label className="fw-bold">Transporter Name</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="transporterName"
                      className="form-control"
                      value={formData.transporterName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Transporter GSTIN */}
                  <div className="col-md-3">
                    <label className="fw-bold">Transporter GSTIN</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="transporterGSTIN"
                      className="form-control"
                      value={formData.transporterGSTIN}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Document/GR No. */}
                  <div className="col-md-3">
                    <label className="fw-bold">Document/GR No.</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="documentGRNo"
                      className="form-control"
                      value={formData.documentGRNo}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Document/GR Date */}
                  <div className="col-md-3">
                    <label className="fw-bold">Document/GR Date</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      name="documentGRDate"
                      className="form-control"
                      value={formData.documentGRDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </>
            ):null}
          </>
        ) : formData.gatePassCause == 'वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |' ? (
          <>
            {/* Satsang Vehicle */}
            <div className="row mb-3">
              {/* Label */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">क्या सत्संग घर का वाहन है ?</label>
              </div>

              {/* Options */}
              <div className="col-md-9">
                <div className="border rounded p-2">
                  {['हां', 'नहीं'].map((label, idx) => {
                    const id = `isBilwaVehicle-${idx}`;
                    return (
                      <div key={label} className="form-check">
                        <input
                          type="radio"
                          id={id}
                          className="form-check-input"
                          style={{ appearance: 'checkbox' }}
                          name="isBilwaVehicle"
                          value={label}
                          checked={formData.isBilwaVehicle == (label == 'हां')}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              isBilwaVehicle: e.target.value == 'हां'
                            }))
                          }
                        />
                        <label htmlFor={id} className="form-check-label">{label}</label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Purpose */}
            <div className="row mb-3">
              {/* Label */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">उद्देश्य</label>
              </div>
              {/* Field */}
              <div className="col-md-9">
                <div className={formData.purpose ? "" : "border border-danger rounded"}>
                  <Select
                    options={purposeOptions}
                    value={formData.purpose}
                    onChange={(option) =>
                      setFormData((prev) => ({ ...prev, purpose: option }))
                    }
                    isClearable
                  />
                </div>
                {!formData.purpose && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            {/* Inward Memo */}
            {formData.purpose?.value == 'वापसी योग्य सामान जिसका इन्वार्ड मेमो बनाया गया था' ? (
              <div className="row mb-3">
                {/* Label: Inward Memo Number */}
                <div className="col-md-3 d-flex align-items-center">
                  <label className="fw-bold mb-0" style={{ whiteSpace: 'nowrap' }}>
                    इन्वार्ड मेमो संख्या
                  </label>
                </div>
                {/* Input: Inward Memo Number */}
                <div className="col-md-3">
                  <input
                    type="text"
                    name="inwardMemoNo"
                    className={`form-control ${!formData.inwardMemoNo ? 'border-danger' : ''}`}
                    value={formData.inwardMemoNo}
                    onChange={handleChange}
                  />
                  {!formData.inwardMemoNo && (
                    <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                  )}
                </div>

                {/* Label: Inward Memo Date */}
                <div className="col-md-3 d-flex align-items-center">
                  <label className="fw-bold mb-0" style={{ whiteSpace: 'nowrap' }}>
                    इन्वार्ड मेमो दिनांक
                  </label>
                </div>
                {/* Input: Inward Memo Date */}
                <div className="col-md-3">
                  <input
                    type="date"
                    name="inwardMemoDate"
                    className={`form-control ${!formData.inwardMemoDate ? 'border-danger' : ''}`}
                    value={formData.inwardMemoDate}
                    onChange={handleChange}
                  />
                  {!formData.inwardMemoDate && (
                    <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                  )}
                </div>
              </div>
            ):null}

            {formData.purpose?.value == 'संगत और सेवादारों को लाने व ले जाने के लिए' ? (
              <div className="row mb-3">
                {/* Label */}
                <div className="col-md-3 d-flex align-items-center">
                  <label
                    className="fw-bold mb-0"
                    style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
                  >
                    क्या वाहन में सत्संग घर का कोई सामान ले जाया जा रहा है ?
                  </label>
                </div>

                {/* Radio Options */}
                <div
                  className={`col-md-9 border rounded p-2 ${formData.isCarryingGoods == undefined ? 'border-danger' : ''
                    }`}
                >
                  {['हां', 'नहीं'].map((label, idx) => {
                    const id = `isCarryingGoods-${idx}`;
                    return (
                      <div key={label} className="form-check">
                        <input
                          type="radio"
                          id={id}
                          className="form-check-input"
                          style={{ appearance: 'checkbox' }}
                          name="isCarryingGoods"
                          value={label}
                          checked={formData.isCarryingGoods == (label == 'हां')}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              isCarryingGoods: e.target.value == 'हां',
                            }))
                          }
                        />
                        <label htmlFor={id} className="form-check-label">
                          {label}
                        </label>
                      </div>
                    );
                  })}
                </div>

                {/* Error Message */}
                {formData.isCarryingGoods == undefined && (
                  <div className="col-md-12">
                    <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                  </div>
                )}
              </div>
            ):null}

            {(formData.isCarryingGoods && formData.purpose?.value == 'संगत और सेवादारों को लाने व ले जाने के लिए') ? (
              <div className="row mb-3">
                {/* Challan Number */}
                <div className="col-md-3 d-flex align-items-center">
                  <label className="fw-bold mb-0" style={{ whiteSpace: 'nowrap' }}>
                    चालान संख्या
                  </label>
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    name="challanNo"
                    className={`form-control ${!formData.challanNo ? 'is-invalid' : ''}`}
                    value={formData.challanNo}
                    onChange={handleChange}
                  />
                  {!formData.challanNo && (
                    <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                  )}
                </div>

                {/* Challan Date */}
                <div className="col-md-3 d-flex align-items-center">
                  <label className="fw-bold mb-0" style={{ whiteSpace: 'nowrap' }}>
                    चालान दिनांक
                  </label>
                </div>
                <div className="col-md-3">
                  <input
                    type="date"
                    name="challanDate"
                    className={`form-control ${!formData.challanDate ? 'is-invalid' : ''}`}
                    value={formData.challanDate}
                    onChange={handleChange}
                  />
                  {!formData.challanDate && (
                    <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                  )}
                </div>
              </div>
            ):null}

            {/* Vehicle, Driver, Mobile */}
            {/* First row (Vehicle Number & Driver Name) */}
            <div className="row mb-3">
              {/* Vehicle Number */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">वाहन संख्या</label>
              </div>

              <div className="col-md-3">
                {formData?.isBilwaVehicle ? (
                  <Select
                    name="vehicleNumber"
                    options={vehicleOptions}
                    value={vehicleOptions.find(opt => opt.value == formData.vehicleNumber) || null}
                    onChange={(selected) =>
                      handleChange({
                        target: { name: "vehicleNumber", value: selected ? selected.value : "" },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                ) : (
                  <>
                    <input
                      type="text"
                      name="vehicleNumber"
                      className={`form-control ${!formData.vehicleNumber ? "is-invalid" : ""}`}
                      value={formData.vehicleNumber}
                      onChange={handleChange}
                    />
                    {!formData.vehicleNumber && (
                      <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                    )}
                  </>
                )}
              </div>

              {/* Driver Name */}

              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">वाहन चालक की बैज आईडी</label>
              </div>

              <div className="col-md-3">
                {formData.isBilwaVehicle ? (
                  <>
                    <Select
                      name="badgeId"
                      options={securitySewadars} // format: [{ value: "John Doe", label: "John Doe" }]
                      value={
                        securitySewadars.find(opt => opt.value == formData.badgeId) || null
                      }
                      onChange={(selected) => {
                        handleChange({
                          target: {
                            name: "badgeId",
                            value: selected ? selected.value : "",
                          },
                        });
                        handleChange({
                          target: {
                            name: "driverName",
                            value: selected ? selected.name : "",
                          },
                        });
                        handleChange({
                          target: {
                            name: "mobileNumber",
                            value: selected ? selected.sewadarMobileNo : "",
                          },
                        });
                      }}                      
                      classNamePrefix="react-select"
                    />
                    {!formData.badgeId && (
                      <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      name="badgeId"
                      className={`form-control ${!formData.badgeId ? "is-invalid" : ""
                        }`}
                      value={formData.badgeId}
                      onChange={handleChange}
                    />
                    {!formData.badgeId && (
                      <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                    )}
                  </>
                )}
              </div>

            </div>

            {/* Second row (Mobile Number) */}
            <div className="row mb-3">
            <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">वाहन चालक का नाम</label>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  name="driverName"
                  className={`form-control ${!formData.driverName ? 'is-invalid' : ''}`}
                  value={formData.driverName}
                  onChange={handleChange}
                />
                {!formData.driverName && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
              {/* Mobile Number */}
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">मोबाइल नंबर</label>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  name="mobileNumber"
                  className={`form-control ${!formData.mobileNumber ? 'is-invalid' : ''}`}
                  value={formData.mobileNumber}
                  onChange={handleChange}
                />
                {!formData.mobileNumber && (
                  <small className="text-danger">यह फ़ील्ड आवश्यक है</small>
                )}
              </div>
            </div>

            {/* Ledger & Remarks */}
            {/* Row for सत्संग सेंटर / सत्संग पॉइंट */}
            <div className="row mb-3">
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">सत्संग सेंटर / सत्संग पॉइंट</label>
              </div>
              <div className="col-md-9">
                <Select
                  options={ledgerOptions}
                  value={formData.ledgerName}
                  onChange={(option) => handleLedgerChange("ledgerName", option)}
                  isClearable
                />
              </div>
            </div>

            {/* Row for अन्य कोई विवरण */}
            <div className="row mb-3">
              <div className="col-md-3 d-flex align-items-center">
                <label className="fw-bold mb-0">अन्य कोई विवरण</label>
              </div>
              <div className="col-md-9">
                <input
                  type="text"
                  name="remarks"
                  className="form-control"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>
          </>
        ) : null}

        {/* Items Table */}
        {(formData.purpose?.value == 'सामुदायिक उपभोग के लिए उपभोग्य सामग्रियों का वितरण' &&
          formData.gatePassCause == 'वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |') ? (
            <div className="mt-4">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: "40%" }}>Item</th>
                    <th style={{ width: "20%" }}>Quantity</th>
                    <th style={{ width: "20%" }}>UOM</th>
                    <th style={{ width: "20%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.items?.map((itemRow, index) => (
                    <tr key={index}>
                      <td>
                        <Select
                          options={itemOptions}
                          value={itemRow.item}
                          onChange={(selected) => handleItemTableChange(index, 'item', selected)}
                          isClearable
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={itemRow.quantity}
                          onChange={(e) => handleItemTableChange(index, 'quantity', e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={itemRow.uom}
                          readOnly
                        />
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeItemRow(index)}
                            disabled={formData.items.length == 1}
                          >
                            Remove
                          </button>
                          {index == formData.items.length - 1 ? (
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={addItemRow}
                            >
                              Add
                            </button>
                          ):null}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ):null}
        <button type="submit" className="btn btn-success mt-3">Submit</button>
      </form>


    </div>
  );
};

export default GatePass;
